import { FC, memo, useCallback, useEffect, useState } from 'react'

import { IconName } from '../Icon'
import { Layer } from '../Layer'

/**
 
{
  Actions,
  Body,
  Container,
  PrimaryHeader,
  PrimaryTitle,
  SecondaryHeader,
  SecondaryTitle,
  WrappedButton
}

 */
import { PanelProps } from './PanelProps'
import { PanelFace } from './panelFace'

import * as SC from './styles'

const panelFaceTitles = {
  [`${PanelFace.PRIMARY}`]: SC.PrimaryTitle,
  [`${PanelFace.SECONDARY}`]: SC.SecondaryTitle,
  [`${PanelFace.SMALL_PRIMARY}`]: SC.SmallPrimaryTitle
}

const panelFaceHeader = {
  [`${PanelFace.PRIMARY}`]: SC.PrimaryHeader,
  [`${PanelFace.SECONDARY}`]: SC.SecondaryHeader,
  [`${PanelFace.SMALL_PRIMARY}`]: SC.SmallPrimaryHeader
}

export const Panel: FC<PanelProps> = memo((props) => {
  const {
    children,
    expanded,
    title,
    face = PanelFace.PRIMARY,
    onToggle,
    actions,
    rounded,
    shadowed,
    stretch,
    collapsible = true,
    anchor,
    isArrowButton = false,
    disabled = false,
    titleTagAs = 'h1',
    blockOnClickOnTitle = false,
    ...rest
  } = props
  const [localExpanded, setLocalExpanded] = useState<boolean>(expanded || true)
  const Header = panelFaceHeader[face]
  const Title = panelFaceTitles[face]

  useEffect(() => {
    if (typeof expanded !== 'undefined') {
      setLocalExpanded(expanded)
    }
  }, [expanded, setLocalExpanded])

  const onLocalToggle = useCallback(() => {
    if (!disabled) {
      setLocalExpanded(!localExpanded)
      if (onToggle) {
        onToggle(!localExpanded)
      }
    }
  }, [localExpanded, setLocalExpanded, onToggle, disabled])

  let icon: IconName

  if (isArrowButton) icon = !localExpanded || disabled ? IconName.EXPAND_MORE : IconName.EXPAND_LESS
  else icon = localExpanded ? IconName.CLOSE_BUTTON : IconName.OPEN_BUTTON

  return (
    <Layer rounded={rounded} shadowed={shadowed} stretch={stretch} id={anchor} {...rest}>
      <SC.Container>
        {(collapsible || !!title || !!actions) && (
          <Header expanded={localExpanded} $disabled={disabled}>
            <Title
              as={titleTagAs}
              $clicable={collapsible}
              onClick={collapsible && !blockOnClickOnTitle ? onLocalToggle : undefined}
            >
              {collapsible && (
                <SC.WrappedIcon name={icon} onClick={onLocalToggle} data-qa="toggle-filter-btn" $disabled={disabled} />
              )}
              {title}
            </Title>
            {!!actions && <SC.Actions>{actions}</SC.Actions>}
          </Header>
        )}
        <SC.Body expanded={localExpanded}>{localExpanded && children}</SC.Body>
      </SC.Container>
    </Layer>
  )
})
